import React from "react";
import '../css/TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service-container">
      <section className="main-section-header">
        <div className="main-container">
          <div className="subheader cta-color">Terms of Service</div>
        </div>
      </section>
      <section className="terms-of-service-content">
        <div className="main-container">
          <h3><strong>Last updated:</strong> September 29, 2025</h3><br/>

          <h3>1. Agreement to Terms</h3>
          <p>
            By accessing and using the Furloop Google Sheets Integration service ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Service.
          </p>

          <h3>2. Description of Service</h3>
          <p>This Service enables authorized resellers to manage their product catalog through Google Sheets. Key features include:</p><br/>
          <ul>
            <li>Exporting product data to Google Sheets</li>
            <li>Editing product prices in Google Sheets</li>
            <li>Synchronizing price changes back to your business system</li>
          </ul>

          <h3>3. User Accounts and Access</h3>
          <p>To use the Service, you must:</p><br/>
          <ul>
            <li>Be an authorized reseller with a valid Furloop account</li>
            <li>Have a Google account with access to Google Sheets</li>
            <li>Provide accurate and complete account information when connecting services</li>
          </ul>

          <h3>4. Data and Privacy</h3>
          <p>We take data protection seriously. Specifically:</p><br/>
          <ul>
            <li><strong>Data Access:</strong> We access only Google Sheets created by our app for your product data.</li>
            <li><strong>Data Storage:</strong> OAuth tokens are securely stored and used solely for authorized syncing.</li>
            <li><strong>Data Sharing:</strong> We do not share your product data with third parties.</li>
            <li><strong>Data Retention:</strong> You can revoke access at any time through the interface.</li>
          </ul>

          <h3>5. Acceptable Use</h3>
          <p>You agree to use the Service only for lawful, legitimate business purposes:</p><br/>
          <ul>
            <li>Managing your own product catalogs and pricing</li>
            <li>Complying with relevant laws and regulations</li>
            <li>Not attempting to access other users' data</li>
            <li>Not using the Service to violate third-party rights</li>
          </ul>

          <h3>6. Service Availability</h3>
          <p>We aim to provide a reliable experience but do not guarantee uninterrupted access:</p><br/>
          <ul>
            <li>The Service is provided "as is"</li>
            <li>Scheduled maintenance may affect availability</li>
            <li>Google API limitations may impact functionality</li>
          </ul>

          <h3>7. User Responsibilities</h3>
          <p>As a user, you are responsible for:</p><br/>
          <ul>
            <li>Keeping your account credentials secure</li>
            <li>Backing up critical data before bulk changes</li>
            <li>Ensuring the accuracy of synced pricing data</li>
            <li>Reporting any security issues or unauthorized access</li>
          </ul>

          <h3>8. Limitations of Liability</h3>
          <p>To the maximum extent allowed by law:</p><br/>
          <ul>
            <li>We are not liable for data loss or corruption</li>
            <li>We are not responsible for user-generated pricing errors</li>
            <li>Our total liability is limited to fees paid for the Service</li>
            <li>We are not liable for indirect or incidental damages</li>
          </ul>

          <h3>9. Service Modifications</h3>
          <p>We may:</p><br/>
          <ul>
            <li>Modify or discontinue the Service with reasonable notice</li>
            <li>Update these Terms at any time</li>
            <li>Change API endpoints or features</li>
            <li>Implement security updates that may affect use</li>
          </ul>

          <h3>10. Termination</h3>
          <p>Access may be terminated in the following cases:</p><br/>
          <ul>
            <li>You may disconnect Google Sheets integration at any time</li>
            <li>We may suspend access for violations of these Terms</li>
            <li>On termination, OAuth tokens are deleted</li>
            <li>Any Google Sheets created remain in your Drive</li>
          </ul>

          <h3>11. Google Services</h3>
          <p>This Service relies on integration with Google services:</p><br/>
          <ul>
            <li>Your use of Google services is governed by Google's own Terms</li>
            <li>We are not responsible for changes to Google's APIs or policies</li>
            <li>Google's privacy policies apply to your Google account data</li>
          </ul>

          <h3>12. Intellectual Property</h3>
          <p>
            Furloop retains all rights to the Service and its technology. You retain ownership of your product data and any Google Sheets content.
          </p>

          <h3>13. Governing Law</h3>
          <p>
            These Terms are governed by the laws of Australia. Disputes will be resolved in Australian courts.
          </p>

          <h3>14. Contact Information</h3>
          <p>If you have any questions about these Terms, contact us:</p><br/>
          <p>
            <strong>Email:</strong> help@furloop.io<br/>
            <strong>Website:</strong> https://furloop.io
          </p>

          <h3>15. Changes to Terms</h3>
          <p>
            We may update these Terms over time. We'll notify users of significant changes via our platform. Continued use after changes constitutes acceptance of the updated Terms.
          </p>

          <p>
            <strong>By using the Furloop Google Sheets Integration, you confirm that you have read, understood, and agreed to these Terms of Service.</strong>
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;